import React, { useState } from 'react';
import * as Icons from '../../assets/images/allergens/AllergenIcons';
import { Tooltip, IconButton } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import '../../styles/SectionItem.scss';

const SectionItem = ({ isOpen, item, section }) => {
    const [openTooltip, setOpenTooltip] = useState(false);

    const handleTooltipToggle = () => {
        setOpenTooltip((prev) => !prev);
    };

    return (
        <div key={item.id} className={"menu-item " + (isOpen.includes(section.id) ? "_collapsed" : "")}>
            <div>
                <div className="item-name-icon">
                    <h4>
                        {item.name}

                    
                    {item.allergens?.length > 0 && (
                        <Tooltip
                            open={openTooltip}
                            title={
                                <div className="allergen-tooltip-content">
                                    {item.allergens.map((allergen, index) => {
                                        const IconComponent = Icons.findAllergenComponent(allergen);
                                        return (
                                            <div key={index} className="allergen-info">
                                                <span className="allergen-icon">
                                                    {IconComponent ? React.cloneElement(IconComponent, { className: 'icon-svg' }) : <ErrorOutlineIcon />}
                                                </span>
                                                <span>{allergen}</span>
                                            </div>
                                        );
                                    })}
                                </div>
                            }
                            onClose={() => setOpenTooltip(false)}
                            disableTouchListener
                            arrow
                        >
                            <IconButton
                                onClick={handleTooltipToggle}
                                className="allergen-warning-icon"
                                size="small"
                                sx={{ color: '#faa916' }}
                            >
                                <ErrorOutlineIcon />
                            </IconButton>
                        </Tooltip>
                    )}
                    </h4>
                </div>
                <span>{item.description}</span>
            </div>
            <p className="price">{item.price?.includes("€") ? item.price : `${item.price} €`}</p>
        </div>
    );
};

export default SectionItem;
